
import React from 'react'
import { Settings } from 'react-feather'
import Button from './Button'

/**
 * EditButton component.
 */

export default function EditButton({ ...props }) {
  return <Button is="a" theme="minimal" icon={Settings} {...props} />
}